<template>
  <div class="get-product">

    <div class="get-product__input-wrap">
      <app-input
          v-on:input="searchProduct"
          v-model="product.inputValue"
          :placeholder="'Выберито товар'"
      />
    </div>

    <div v-if="product.list.length" class="get-product__list">
      <product-item @change="chooseProduct" v-for="item in product.list" :key="item.id" :shopUrl="shopUrl" :item="item"/>
    </div>
  </div>
</template>

<script>
import { Server } from "../../api";
import appInput from "../base-ui/app-input";
import productItem from './productItem';
export default {
  name: 'get-product',
  data: function () {
    return {
      product: {
        inputValue: '',
        list: [],
        valueProp: ''
      },
    };
  },
  methods: {
    emitValue(value) {
      this.$emit('change', value)
    },
    chooseProduct: function (data) {
      this.product.inputValue = `${data.itemData.title}  ${data.itemData.mode}`;
      this.product.valueProp = this.product.inputValue;
      this.product.list = [];
      this.emitValue(data)
    },
    searchProduct: async function () {
      this.$emit('input', this.product.inputValue)

      this.product.list = await Server.searchProduct({
        shopHostUrl: `${window.location.protocol}//${this.shopUrl}`,
        value: this.product.inputValue
      })
          .then(response => {
            if (response && response.statusCode && response.statusCode === 401) {
              return this.$store.dispatch('logoutAccount')
            }
            if (! response.length) {
              throw new Error(response);
            }
            return response;
          })
          .catch(() => {
            return [];
          })
    },
    getUserAccountData: async function () {
      // Если нет, то делаем запрос
      if (! Object.keys(this.$store.state.account.accountData).length) {
        this.$store.dispatch('getAccountData')
            .then(response => {
              if (response && response.statusCode && response.statusCode === 401) {
                return this.$store.dispatch('logoutAccount')
              }
            })
      }
    },
    getData: function() {
      this.getUserAccountData();
    }
  },
  computed: {
    shopUrl: function () {
      return this.$store.state.account.accountData.insales_shop_url || this.$store.state.account.accountData.shop_url;
    }
  },
  components: {
    'app-input': appInput,
    'product-item': productItem
  },
  mounted() {
    this.getData();
  }
}
</script>
<style lang="scss">
.get-product {
  position: relative;
  &__list {
    border: 2px solid var(--color-border);
    border-radius: 30px;
    padding: 10px;
    padding-top: 60px;
    margin-top: -50px;
    position: absolute;
    z-index: 1;
    background: #fff;
    width: 100%;
  }
  &__input-wrap {
    position: relative;
    z-index: 3;
  }
  &__result {
    font-size: 14px;
    font-weight: 600;
    margin-top: 10px;
  }
}
</style>